export default __webpack_public_path__ + "static/media/icon-shield.7292764d.svg";